import React from 'react';
import type { FC } from 'react';
import styled from 'styled-components';
import { DynamicImage, Text } from 'components';
import { mobile, tablet, useQuery } from 'styles/breakpoints';
import theme, { Typography } from 'utils/theme';

interface HeaderProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  imageAlt: string;
  optionsLabelFont?: Typography;
  imageHeightDesktop: string;
  imageHeightTablet: string;
  imageHeightMobile: string;
  titleAlign?: string;
  topLabel?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${tablet} {
  }
`;

const StyledDynamicImage = styled(DynamicImage)<{
  imageHeightDesktop: string;
  imageHeightTablet: string;
  imageHeightMobile: string;
}>`
  height: ${({ imageHeightDesktop }) => imageHeightDesktop};

  @media ${tablet} {
    height: ${({ imageHeightTablet }) => imageHeightTablet};
  }

  @media ${mobile} {
    height: ${({ imageHeightMobile }) => imageHeightMobile};
  }
`;

const Title = styled(Text)<{ titleAlign: string }>`
  text-align: ${({ titleAlign }) => titleAlign};
  color: #000;
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.0625rem;
  max-width: 28.75rem;
  width: 100%;
  padding-bottom: 0.5rem;
  text-align: center;
  @media ${tablet} {
    font-size: 1.375rem;
    line-height: 2rem;
    font-weight: 700;
  }
`;

const OptionsLabel = styled(Text)`
  color: #000;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4375rem;
  text-align: center;
  @media ${tablet} {
    font-size: 0.8125rem;
    line-height: normal;
  }
`;

const TopLabel = styled(Text)`
  color: #000;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4375rem;
  margin-bottom: 0.5rem;
  @media ${tablet} {
    font-size: 0.875rem;
    line-height: normal;
  }
`;

const Header: FC<HeaderProps> = ({
  title,
  subtitle,
  imageUrl,
  imageAlt,
  optionsLabelFont,
  imageHeightDesktop,
  imageHeightTablet,
  imageHeightMobile,
  titleAlign = 'left',
  topLabel,
}) => {
  const { isMobile } = useQuery();
  return (
    <Container>
      {imageUrl ? (
        <StyledDynamicImage
          src={imageUrl}
          alt={imageAlt}
          imageHeightDesktop={imageHeightDesktop}
          imageHeightTablet={imageHeightTablet}
          imageHeightMobile={imageHeightMobile}
        />
      ) : null}
      {topLabel && <TopLabel>{topLabel}</TopLabel>}
      <Title titleAlign={titleAlign}>{title}</Title>
      {subtitle ? (
        <OptionsLabel
          type={
            optionsLabelFont
              ? optionsLabelFont
              : isMobile
              ? 'caption'
              : 'caption'
          }
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      ) : null}
    </Container>
  );
};

export default React.memo(Header);
